import type { AppRouter } from "@app-trpc/server/api/trpc/[trpc]";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import type { ZodFormattedError } from "zod";

export type GetGeneralSettingsInput =
  inferRouterInputs<AppRouter>["general"]["get"];
export type GetGeneralSettingsOutput =
  inferRouterOutputs<AppRouter>["general"]["get"];

export type UpdateGeneralSettingsInput =
  inferRouterInputs<AppRouter>["general"]["update"];
export type UpdateGeneralSettingsOutput =
  inferRouterOutputs<AppRouter>["general"]["update"];

export class UpdateGeneralSettingsError extends Error {
  zodError?: ZodFormattedError<UpdateGeneralSettingsInput>;

  constructor(zodError?: ZodFormattedError<UpdateGeneralSettingsInput>) {
    const message = zodError ? "Validation error" : "Unknown error";

    super(message);
    this.name = "UpdateGeneralSettingsError";
    this.zodError = zodError;
  }
}

export const useGeneralSettingsClient = () => {
  const client = useNuxtApp().$client;

  async function get(): Promise<GetGeneralSettingsOutput> {
    return client.general.get.query();
  }

  async function update(
    input: UpdateGeneralSettingsInput
  ): Promise<UpdateGeneralSettingsOutput> {
    try {
      return await client.general.update.mutate(input);
    } catch (e: any) {
      throw new UpdateGeneralSettingsError(e.data?.zodError);
    }
  }

  return {
    get,
    update,
  };
};
